<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ywwbNy/tc-custom/FC-9781528976305.jpg?1684515369269?1705541169369" alt="This image is the cover for the book Memoirs of a Removal Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memoirs of a Removal Man
      </h1>
      <p class="bookDescription body article font2">
        <p>Moving houses has been likened to death and divorce in the list of most stressful experiences. Graham Willis delves into his diaries for funny, horrendous and sometimes heartbreaking stories of moving home over the last 30 years. Memoirs of a Removal Man is a tribute to all the hardworking men and women he has worked with and is a must-read for everyone who has ever moved home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Graham Willis
      </h2>
      
      <p class="authorDescription body article">Graham Willis was born in 1961 and lives in London with his wife, Sheila, and their son, Kylam. He has worked in the removals and storage business for 30 years which was originally started by his family in 1930. This is his first book and is a tribute to all the family and friends who have supported him through the years, especially his mum and dad.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e721daf